import React from 'react';
import OtherPartnersComponent from '../../../Components/UserComponents/OtherPartners';

const OtherPartnersContainer = () => {
  return <OtherPartnersComponent />;
};

export default OtherPartnersContainer;
